<template>
  <div>
    <v-breadcrumbs
        divider=">"
        :items="items"
    ></v-breadcrumbs>
    <v-form v-model="valid">
      <v-row no-gutters align="center" >
        <v-col
            cols="1"
            style="text-align: right"
        >
          <label>系统合同号：</label>
        </v-col>
        <v-col
            cols="2"
        >
          <v-text-field
              v-model="filter.contractId"
              dense
              outlined
          ></v-text-field>
        </v-col>
        <v-col
            cols="1"
            style="text-align: right"
        >
          <label>物理合同号：</label>
        </v-col>
        <v-col
            cols="2"
        >
          <v-text-field
              v-model="filter.contractCode"
              single-line
              outlined
              dense
          ></v-text-field>
        </v-col>
        <v-col
            cols="1"
            style="text-align: right"
        >
          <label>客商：</label>
        </v-col>
        <v-col
            cols="2"
        >
          <merchants-select v-model="filter.merchants"></merchants-select>
        </v-col>
        <v-col
            cols="1"
            style="text-align: right"
        >
          <label>合同起止日期：</label>
        </v-col>
        <v-col
            cols="2"
        >
          <date-range label="" v-model="filter.dateRange"></date-range>
        </v-col>
        <v-col
            cols="1"
            style="text-align: right"
        >
          <label>合同类型：</label>
        </v-col>
        <v-col
            cols="2"
        >
          <contract-type v-model="filter.contractType"></contract-type>
        </v-col>
        <v-col
            cols="1"
            style="text-align: right"
        >
          <label>合同状态：</label>
        </v-col>
        <v-col
            cols="2"
        >
          <v-select
              v-model="filter.status"
              :items="statusList"
              item-text="name"
              item-value="id"
              outlined
              dense
          ></v-select>
        </v-col>
        <v-col
            cols="1"
            style="text-align: right"
            v-if="contractStage == 2"
        >
          <label>门店：</label>
        </v-col>
        <v-col
            cols="2"
            v-if="contractStage == 2"
        >
          <store-select v-model="filter.storeId"></store-select>
        </v-col>
        <v-col
            cols="2"
            offset="1"
        >
            <v-btn
                color="primary"
                depressed
                style="margin-right: 5px"
                @click="handleSearch"
            >查询</v-btn>
            <v-btn
                depressed
                @click="handleResetSearch"
            >重置</v-btn>

        </v-col>
      </v-row>
    </v-form>

    <v-data-table
        :headers="headers"
        :items="desserts"
        class="elevation-1"
        :loading="loading"
        :server-items-length="totalDesserts"
        :page.sync="filter.page"
        :items-per-page.sync="filter.pageSize"
        @update:page="handlePageChanged"
        @update:items-per-page="handlePageSizeChanged"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  color="primary"
                  depressed
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                  v-if="contractStage == 1 && _hasButtonPermission('新增拓展合同')"
                  @click="addContract(1)"
              >
                新增拓展合同
              </v-btn>
              <v-btn
                  color="primary"
                  depressed
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                  v-if="contractStage == 2 && _hasButtonPermission('新增门店合同')"
                  @click="addContract(2)"
              >
                新增门店合同
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">请选择新增方式</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col
                        cols="12"
                        sm="12"
                        md="12"
                    >
                      <v-radio-group
                          v-model="add.createType"
                          row
                      >
                        <v-radio
                            label="新签"
                            :value="1"
                        ></v-radio>
                        <v-radio
                            label="续签"
                            :value="2"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="12"
                        md="12"
                    >
                      <v-autocomplete
                          outlined
                          dense
                          label="关联合同"
                          v-model="add.linkContract"
                          :items="add.linkContractList"
                          :item-text="getLinkContractTest"
                          item-value="contractId"
                          :disabled="add.createType == 1"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="close"
                >
                  取消
                </v-btn>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="save"
                >
                  确定
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn text color="primary" small v-if="(item.status == 1 || item.status == 2) && _hasButtonPermission('保存合同')" @click="editItem(item)">编辑</v-btn>
        <v-btn text color="primary" small v-if="item.status == 2 && _hasButtonPermission('审核合同')" @click="editItem(item)">审核</v-btn>
        <v-btn text color="primary" small v-if="(item.status == 3 || item.status == 9 || item.status == 8) && _hasButtonPermission('查看合同')" @click="viewItem(item)">查看</v-btn>
        <v-btn text color="primary" small v-if="item.status == 3 && _hasButtonPermission('变更合同')" @click="changeItem(item)">合同变更</v-btn>
        <v-btn text color="primary" small v-if="(item.status == 3 || item.status == 9|| item.status == 8) && _hasButtonPermission('提成基数')" @click="commissionItem(item)">提成基数</v-btn>
        <v-btn text color="primary" small v-if="(item.status == 3 || item.status == 9|| item.status == 8) && _hasButtonPermission('临时费用')" @click="tempItem(item)">临时费用</v-btn>
        <v-btn text color="primary" small v-if="(item.status == 3 || item.status == 9 || item.status == 8) && _hasButtonPermission('历史版本')" @click="historyItem(item)">查看历史版本</v-btn>
      </template>
      <template v-slot:item.date="{ item }">
        {{ item.startDate }}~{{item.endDate}}
      </template>
      <template v-slot:item.storeId="{ item }">
        {{ item.storeId?'门店合同':'拓展合同' }}
      </template>
      <template v-slot:item.createType="{ item }">
        {{ item.createType == 1?'是':'否' }}
      </template>
      <template v-slot:item.totalPrice="{ item }">
        {{ textFormat(item.totalPrice?item.totalPrice/100:'','#,##0.00') }}
      </template>
      <template v-slot:item.paidPrice="{ item }">
        {{ textFormat(item.paidPrice?item.paidPrice/100:'','#,##0.00') }}
      </template>
      <template v-slot:item.accuralPrice="{ item }">
        {{ textFormat(item.accuralPrice?item.accuralPrice/100:'','#,##0.00') }}
      </template>
      <template v-slot:no-data>
        查询出错或没有数据
      </template>
    </v-data-table>
    <!-- 提成基数弹出框-->
    <v-dialog v-model="commission.dialogCommission" max-width="1200px" scrollable>
      <v-card>
        <v-toolbar dense flat>
          <v-toolbar-title>提成基数</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="commission.dialogCommission = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text style="height: 500px;">
          <template>
            <v-data-table
                dense
                :headers="commission.headers"
                :items="commission.desserts"
                item-key="name"
                class="elevation-1"
                hide-default-footer
                :items-per-page="999999999"
            >
              <template v-slot:item.costIndex="{ item }">
                {{ item.costIndex + 1 }}
              </template>
              <template v-slot:item.startDate="{ item }">
                {{ item.startDate }} ~ {{item.endDate}}
              </template>
              <template v-slot:item.method="{ item }">
                {{ commission.methodList[item.method -1].name }}
              </template>
              <template v-slot:item.baseStatus="{ item }">
                {{ commission.baseStatusList[item.baseStatus -1].name }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn text color="primary" small v-if="(commission.contractStatus == 3 && item.baseStatus == 1) && _hasButtonPermission('填写提成基数')" @click="periodItem(item)">填写</v-btn>
                <v-btn text color="primary" small v-if="(commission.contractStatus == 3 && item.baseStatus == 2) && _hasButtonPermission('填写提成基数')" @click="periodItem(item)">修改</v-btn>
                <v-btn text color="primary" small v-if="item.baseStatus == 3" @click="periodItem(item)">查看</v-btn>
              </template>
            </v-data-table>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- 录入提成基数弹出框-->
    <v-dialog v-model="commission.dialogPeriod" max-width="600px" scrollable>
      <v-card>
        <v-toolbar dense flat>
          <v-toolbar-title>录入提成基数</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="commission.dialogPeriod = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text style="height: 550px;">
          <template>
            <v-form ref="periodForm">
              <v-row class="mx-2 mt-1">
                <v-col cols="2">
                  <v-text-field outlined dense readonly label="编号" :value="commission.period.costIndex + 1"></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field outlined dense readonly label="费用类型" :value="commission.period.costName"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field outlined dense readonly label="计算方式" :value="commission.methodList[commission.period.method - 1].name"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field outlined dense readonly label="分期起止日期" :value="commission.period.startDate + ' ~ ' + commission.period.endDate"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <price-input readonly label="费用金额" v-model="actualPrice"></price-input>
                </v-col>
                <v-col cols="6">
                  <price-input label="提成基数" v-model="commission.period.basePrice" :rules="[rules.required]" :disabled="commission.period.baseStatus == 3"></price-input>
                </v-col>
                <v-col cols="6">
                  <v-text-field outlined dense label="提成比率" suffix="%" v-model="commission.period.percentageRate" :rules="[rules.required, rules.rate]" :disabled="commission.period.baseStatus == 3"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <price-input label="基数1" v-model="commission.period.base1" :disabled="commission.period.baseStatus == 3"></price-input>
                </v-col>
                <v-col cols="6">
                  <v-text-field outlined dense label="比率1" suffix="%" v-model="commission.period.rate1" :rules="[ rules.rate]" :disabled="commission.period.baseStatus == 3"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <price-input label="基数2" v-model="commission.period.base2" :disabled="commission.period.baseStatus == 3"></price-input>
                </v-col>
                <v-col cols="6">
                  <v-text-field outlined dense label="比率2" suffix="%" v-model="commission.period.rate2" :rules="[rules.rate]" :disabled="commission.period.baseStatus == 3"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <price-input outlined dense label="基数3" v-model="commission.period.base3" :disabled="commission.period.baseStatus == 3"></price-input>
                </v-col>
                <v-col cols="6">
                  <v-text-field outlined dense label="比率3" suffix="%" v-model="commission.period.rate3" :rules="[rules.rate]" :disabled="commission.period.baseStatus == 3"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <price-input outlined dense label="抵充金额" v-model="commission.period.replacePrice" :disabled="commission.period.baseStatus == 3"></price-input>
                </v-col>
                <v-col cols="12">
                  <v-text-field outlined dense label="备注" v-model="commission.period.remark" :disabled="commission.period.baseStatus == 3"></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="commission.dialogPeriod = false">
            取消
          </v-btn>
          <v-btn color="blue darken-1" text @click="savePeriod" :disabled="commission.period.baseStatus == 3" v-if="_hasButtonPermission('保存提成基数')">
            保存
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 临时费用弹出框 -->
    <v-dialog v-model="temp.dialogTemp" max-width="1200px" scrollable>
      <v-card>
        <v-toolbar dense flat>
          <v-toolbar-title>临时费用</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="temp.dialogTemp = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text style="height: 500px;">
          <v-btn color="primary" depressed class="mb-2" @click="addTemp" :disabled="temp.contractStatus != 3" v-if="_hasButtonPermission('新增临时费用')">新增</v-btn>
          <template>
            <v-data-table
                dense
                :headers="temp.headers"
                :items="temp.desserts"
                item-key="name"
                class="elevation-1"
                hide-default-footer
                :items-per-page="999999999"
            >
              <template v-slot:item.startDate="{ item }">
                {{ item.startDate }} ~ {{item.endDate}}
              </template>
              <template v-slot:item.price="{ item }">
                {{ item.price/100 }}
              </template>
              <template v-slot:item.taxRate="{ item }">
                {{ item.taxRate }}%
              </template>
              <template v-slot:item.status="{ item }">
                {{ temp.statusList[item.status-1].name }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn text color="primary" small v-if="(temp.contractStatus == 3 && (item.status == 1||item.status == 2)) && _hasButtonPermission('新增临时费用')" @click="editTemp(item)">修改</v-btn>
                <v-btn text color="primary" small v-if="(temp.contractStatus == 3 && item.status == 2) && _hasButtonPermission('审核临时费用')" @click="auditTemp(item)">审批</v-btn>
                <v-btn text color="primary" small v-if="(temp.contractStatus == 3 && item.status == 3) && _hasButtonPermission('终止临时费用')" @click="closeTemp(item)">终止</v-btn>
              </template>
            </v-data-table>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- 临时费用弹出框-->
    <v-dialog v-model="temp.dialogEdit" max-width="600px" scrollable>
      <v-card>
        <v-toolbar dense flat>
          <v-toolbar-title>临时费用明细</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="temp.dialogEdit = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text style="height: 300px;">
          <template>
            <v-form ref="tempForm">
              <v-row class="mx-2 mt-1">
                <v-col cols="6">
                  <v-select dense outlined label="费用类型" :items="temp.costTypeList" item-text="costName" item-value="costType" :rules="[rules.required]" v-model="temp.temp.costType"></v-select>
                </v-col>
                <v-col cols="6">
                  <date-picker label="应付日期" v-model="temp.temp.payDate" :rules="[rules.required]"></date-picker>
                </v-col>
                <v-col cols="6">
                  <date-range label="分期日期" :rules="[rules.required]" v-model="temp.temp.dateRange"></date-range>
                </v-col>
                <v-col cols="6">
                  <price-input :rules="[rules.required]" v-model="temp.temp.price" label="含税金额"></price-input>
                </v-col>
                <v-col cols="6">
                  <v-text-field dense outlined suffix="%" label="税率" :rules="[rules.required,rules.number, rules.rate]" v-model="temp.temp.taxRate"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field outlined dense label="备注" v-model="temp.temp.remark" ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="temp.dialogEdit = false">
            取消
          </v-btn>
          <v-btn color="blue darken-1" text @click="saveTemp(2)">
            提交审批
          </v-btn>
          <v-btn color="blue darken-1" text @click="saveTemp(1)" :disabled="temp.temp.status != 1">
            保存
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--审核临时费用弹出框-->
    <v-dialog v-model="temp.dialogAudit" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="text-h5">审核</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                  cols="12"
                  sm="12"
                  md="12"
              >
                <v-radio-group
                    v-model="temp.auditInfo.status"
                    row
                >
                  <v-radio
                      label="通过"
                      :value="3"
                  ></v-radio>
                  <v-radio
                      label="不通过"
                      :value="9"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <v-col
                  cols="12"
                  sm="12"
                  md="12"
              >
                <v-textarea
                    counter
                    outlined
                    label="审核意见"
                    v-model="temp.auditInfo.reason"
                    :rules="[rules.remark]"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="temp.dialogAudit = false"
          >
            取消
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              @click="tempAuditSave"
          >
            确定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 历史版本弹出框 -->
    <v-dialog v-model="history.dialogHistory" max-width="800px" scrollable>
      <v-card>
        <v-toolbar dense flat>
          <v-toolbar-title>查看历史版本</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="history.dialogHistory = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text style="height: 300px;">
          <template>
            <v-data-table
                dense
                :headers="history.headers"
                :items="history.desserts"
                item-key="name"
                class="elevation-1"
                hide-default-footer
                :items-per-page="999999999"
            >
              <template v-slot:item.status="{ item }">
                {{ history.statusList[item.status-1].name }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn text color="primary" small @click="viewHistoryItem(item)">查看</v-btn>
                <v-btn text color="primary" small @click="viewUpdateDescription(item)">查看改动说明</v-btn>
              </template>
            </v-data-table>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- 改动说明弹出框 -->
    <v-dialog v-model="history.dialogDescription" max-width="800px" scrollable>
      <v-card>
        <v-toolbar dense flat>
          <v-toolbar-title>查看历史版本改动说明</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="history.dialogDescription = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text style="height: 300px;">
          <template>
            <v-textarea
                counter
                outlined
                label="改动说明"
                v-model="history.updateDescription"
                disabled
                class="ma-2"
            ></v-textarea>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {default as ContractApi} from "@/api/erp/contract/ContractApi.js";
import ContractType from "@/components/erp/contract/ContractType";
import MerchantsSelect from "@/components/erp/contract/MerchantsSelect";
import StoreSelect from "@/components/erp/contract/StoreSelect";
import PriceInput from "@/components/erp/contract/PriceInput";
export default {
  name: "ContractList",
  components:{PriceInput, StoreSelect, MerchantsSelect, ContractType},
  props: {
    contractStage:{
      type:Number
    },
    buttonPriviledgeList: {
      type: Array,
      default: []
    }
  },
  data: () => ({
    //面包屑
    items: [
      {
        text: '合同管理',
        disabled: true,
        href: 'ContractList',
      },
    ],
    //搜索form
    valid: false,
    filter:{
      contractId:'',
      contractCode:'',
      merchants:{},
      dateRange:[],
      contractType:null,
      status:null,
      storeId:null,
      contractStage:1,
      page:1,
      pageSize:15,
    },
    statusList:[{id:1,name:'待提交'},{id:2,name:'待审批'},{id:4,name:'执行中'},{id:5,name:'已过期'},{id:8,name:'已移交'},{id:9,name:'已终止'}],

    //table
    headers: [
      {text: '系统合同号', align: 'start', width:120,sortable: false, value: 'contractId',},
      { text: '物理合同号', value: 'contractCode',width: 120, sortable: false,},
      { text: '客商', value: 'merchantsName' ,width: 250, sortable: false,},
      { text: '项目名称', value: 'projectName' ,width: 250, sortable: false,},
      { text: '合同起止日期', value: 'date' ,width: 200, sortable: false,},
      { text: '合同类型', value: 'typeName' ,width: 120, sortable: false,},
      { text: '合同状态', value: 'statusName' ,width: 120, sortable: false,},
      { text: '签约门店', value: 'storeName' ,width: 120, sortable: false,},
      { text: '合同阶段', value: 'storeId' ,width: 120, sortable: false,},
      { text: '是否新签', value: 'createType' ,width: 120, sortable: false,},
      { text: '创建人', value: 'createName' ,width: 120, sortable: false,},
      { text: '创建时间', value: 'createTime' ,width: 200, sortable: false,},
      { text: '合同总金额', value: 'totalPrice' ,width: 120, sortable: false,},
      { text: '已付金额', value: 'paidPrice' ,width: 120, sortable: false,},
      { text: '已计提金额', value: 'accuralPrice' ,width: 120, sortable: false,},
      { text: '操作', value: 'actions', sortable: false, width:450 },
    ],
    dialog: false,
    loading: true,
    desserts: [],
    totalDesserts:0,
    editedIndex: -1,

    add:{
      addType:-1,
      createType:1,
      linkContract:null,
      linkContractList:[],
    },

    rules:{
      required: value => (!!value || value === 0) || '必填.',
      int:value => ((!value && value != 0)||(!isNaN(parseInt(value)) && value > 0)) || '只能输入正整数',
      remark:value => (!value || value.length <= 200) || '最多只能200个字',
      number:value=> ((!value && value != 0)||(!isNaN(parseFloat(value)) && value > 0)) || '只能输入数字',
      month: value=> ((!value && value != 0)||(!isNaN(parseInt(value)) && value > 0 && value <= 12)) || '只能输入1-12的数字',
      day: value=> ((!value && value != 0)||(!isNaN(parseInt(value)) && value > 0 && value <= 31)) || '只能输入1-31的数字',
      mobile: value=> ((!value && value != 0)||(/^1[0-9]{10}$/.test(value))) || '请输入正确的手机号',
      rate: value=> ((!value && value !== 0)||(!isNaN(parseFloat(value)) && value > 0 && value <=100)) || '只能输入0-100的数字',
    },
    //提成基数
    commission:{
      dialogCommission: false,
      headers: [
        {text: '费用编号', align: 'start', sortable: false, value: 'costIndex', width: 100},
        { text: '费用类型', value: 'costName',width: 120, sortable: false,},
        { text: '分期起止日期', value: 'startDate' ,width: 200, sortable: false,},
        { text: '计算方式', value: 'method' ,width: 120, sortable: false,},
        { text: '应付日期', value: 'payDate' ,width: 120, sortable: false,},
        { text: '状态', value: 'baseStatus' ,width: 80, sortable: false,},
        { text: '填单人', value: 'baseName' ,width: 100, sortable: false,},
        { text: '填单日期', value: 'baseTime' ,width: 200, sortable: false,},
        { text: '操作', value: 'actions', sortable: false, width:100 },
      ],
      desserts: [],
      methodList:[{id:1,name:'固定金额'},{id:2,name:'无保底纯扣点'},{id:3,name:'扣点取高'}],
      baseStatusList:[{id:1,name:'未录入'},{id:2,name:'已录入'},{id:3,name:'已生效'}],
      contractStatus:1,

      dialogPeriod:false,
      period:{
        method:1
      },
    },
    //临时费用
    temp:{
      dialogTemp: false,
      headers: [
        { text: '费用类型', value: 'costName',width: 100, sortable: false,},
        { text: '应付日期', value: 'payDate' ,width: 120, sortable: false,},
        { text: '分期起止日期', value: 'startDate' ,width: 200, sortable: false,},
        { text: '含税金额', value: 'price' ,width: 100, sortable: false,},
        { text: '税率', value: 'taxRate' ,width: 80, sortable: false,},
        { text: '状态', value: 'status' ,width: 100, sortable: false,},
        { text: '填单人', value: 'createName' ,width: 80, sortable: false,},
        { text: '填单日期', value: 'createTime' ,width: 180, sortable: false,},
        { text: '操作', value: 'actions', sortable: false, width:150 },
      ],
      desserts: [],
      contractStatus:1,

      dialogEdit: false,
      costTypeList:[],
      statusList:[{id:1,name:'待提交'},{id:2,name:'待审批'},{id:3,name:'待支付'},{id:4,name:'已支付'},{id:5,name:'已终止'},{},{},{},{id:9,name:'审批不通过'}],
      temp:{
        contractId:null,
        tempId:null,
        costType:null,
        payDate:null,
        dateRange:[],
        price:null,
        taxRate:null,
        remark:null,
      },
      defaultTemp:{
        tempId:null,
        costType:null,
        payDate:null,
        dateRange:[],
        price:null,
        taxRate:null,
        remark:null,
        status:1,
      },

      dialogAudit:false,
      auditInfo:{
        tempId:null,
        status:3,
        reason:'',
      }
    },
    //查看历史版本
    history:{
      dialogHistory: false,
      headers: [
        {text: '版本编号', align: 'start', sortable: false, value: 'recordId',},
        { text: '变更人', value: 'createName',width: 120, sortable: false,},
        { text: '变更时间', value: 'createTime' ,width: 200, sortable: false,},
        { text: '审批状态', value: 'status' ,width: 120, sortable: false,},
        { text: '操作', value: 'actions', sortable: false, width:200 },
      ],
      desserts: [],
      statusList:[{id:1,name:'审批中'},{id:2,name:'审批通过'},{id:3,name:'审批不通过'}],

      dialogDescription:false,
      updateDescription:'',

      historyBack:false,
      historyItem:null,
    },
  }),
  watch: {
    dialog (val) {
      val || this.close()
    },
  },
  computed:{
    actualPrice(){
      let actualPrice = 0;
      let period = this.commission.period;
      if(period.basePrice){
        let basePrice = parseInt(period.basePrice);
        if(period.percentageRate){
          let percentageRate = parseFloat(period.percentageRate);
          if(period.base1 && period.rate1 && period.base1 > 0){
            let base1 = parseInt(period.base1);
            let rate1 = parseFloat(period.rate1)
            if(basePrice > base1){
              let quick1 = base1 * percentageRate - base1 * rate1;
              if(period.base2 && period.rate2 && period.base2 > base1){
                let base2 = parseInt(period.base2);
                let rate2 = parseFloat(period.rate2);
                if(basePrice > base2){
                  let quick2 = quick1 + base2 * rate1 - base2 * rate2;
                  if(period.base3 && period.rate3 && period.base3 > base2){
                    let base3 = parseInt(period.base3);
                    let rate3 = parseFloat(period.rate3);
                    if(basePrice > base3){
                      let quick3 = quick2 + base3 * rate2 - base3 * rate3;
                      actualPrice = period.basePrice * rate3 + quick3;
                    }else{
                      actualPrice = period.basePrice * rate2 + quick2;
                    }
                  }else{
                    actualPrice = period.basePrice * rate2 + quick2;
                  }
                }else{
                  actualPrice = period.basePrice * rate1 + quick1;
                }
              }else{
                actualPrice = period.basePrice * rate1 + quick1;
              }
            }else{
              actualPrice = period.basePrice * percentageRate;
            }
          }else{
            actualPrice = period.basePrice * percentageRate;
          }
        }
      }
      actualPrice = parseInt(actualPrice/100); //除以100是为了%，不是为了分转元
      if(period.replacePrice){
        actualPrice -= period.replacePrice;
      }
      return actualPrice;
    }
  },
  created() {
    this.listTempCostType();
  },
  mounted () {
    this.filter.contractStage = this.contractStage
    this.getDataFromApi()
  },
  methods: {
    handleSearch(){
      this.filter.page = 1;
      this.getDataFromApi();
    },

    handleResetSearch(){
      this.filter = {
        contractId:'',
        contractCode:'',
        merchants:{},
        dateRange:[],
        contractType:null,
        status:null,
        storeId:null,
        contractStage:this.contractStage,
        page:1,
        pageSize:15,
      }
      this.getDataFromApi();
    },

    getDataFromApi () {
      this.loading = true;
      this.desserts = [];
      let me = this;
      ContractApi.list(this.getQueryParams(this.filter)).then(data=>{
          me.loading = false;
          me.desserts = data.rows;
          me.totalDesserts = data.total;
      }).catch(error=>{
          me.loading = false;
      })
      if(this.history.historyBack){
        this.history.historyBack = false;
        this.historyItem(this.history.historyItem);
      }
    },
    getQueryParams(param) {
      let query = Object.assign({}, param);
      let rangeDate = query.dateRange
      if (rangeDate && rangeDate.length) {
        query.startDate = rangeDate[0]
        query.endDate = rangeDate[1]
        delete query.dateRange;
      }

      let merchants = query.merchants;
      if(merchants){
        query.merchantsId = merchants.merchantsId;
      }
      return query
    },

    handlePageChanged(page) {
      this.filter.page = page
      this.getDataFromApi()
    },

    handlePageSizeChanged(pageSize) {
      this.filter.page = 1
      this.filter.pageSize = pageSize
      this.getDataFromApi()
    },

    addContract(addType){
      this.add.addType = addType;
      let me = this;
      ContractApi.list({pageSize:-1,status:3,contractStage:this.filter.contractStage}).then(data=>{
          me.add.linkContractList = data.rows;
      })
    },

    getLinkContractTest(contract){
      return `${contract.contractCode}(${contract.projectName})`;
    },

    commissionItem (item) {
      this.commission.dialogCommission = true;
      let me = this;
      ContractApi.getContract({contractId:item.contractId}).then(data=>{
          let periodList = data.periodList;
          me.commission.desserts = periodList.filter(period=>period.method == 2 || period.method == 3);
          me.commission.contractStatus = data.status;
      })
    },
    periodItem(item){
      this.commission.period = item;
      this.commission.dialogPeriod = true;
    },
    savePeriod(){
      let formValid = this.$refs.periodForm.validate();
      if(formValid){
        let me = this;
        this.commission.period.actualPrice = this.actualPrice;
        ContractApi.savePeriodBase(this.commission.period).then(data=>{
            me.commission.dialogPeriod = false;
            me.commissionItem({contractId:me.commission.period.contractId});
            me.$dialog.info({
              title:'操作成功',
              text: '保存成功',
            })
        })
      }
    },

    tempItem (item) {
      this.temp.dialogTemp = true;
      let me = this;
      ContractApi.getContract({contractId:item.contractId}).then(data=>{
          me.temp.desserts = data.tempList;
          me.temp.contractStatus = data.status;
          me.temp.temp.contractId = data.contractId;
      })
    },

    listTempCostType(){
      let me = this;
      ContractApi.listCostType({type:2}).then(data=>{
          me.temp.costTypeList = data;
      })
    },

    addTemp(){
      Object.assign(this.temp.temp, this.temp.defaultTemp)
      this.temp.dialogEdit = true;
    },

    editTemp(item){
      this.temp.temp = item;
      this.temp.temp.dateRange = [item.startDate, item.endDate];
      this.temp.dialogEdit = true;
    },

    saveTemp(status){
      let formValid = this.$refs.tempForm.validate();
      if(formValid){
        let temp = this.temp.temp;
        temp.status = status;
        temp.startDate = temp.dateRange[0];
        temp.endDate = temp.dateRange[1];
        let me = this;
        ContractApi.saveTemp(temp).then(data=>{
            me.temp.dialogEdit = false;
            me.tempItem({contractId:temp.contractId});
            me.$dialog.info({
              title:'操作成功',
              text: '保存成功',
            })
        })
      }
    },
    auditTemp(item){
      this.temp.auditInfo.tempId = item.tempId;
      this.temp.dialogAudit = true;
    },
    tempAuditSave(){
      let me = this;
      ContractApi.auditTemp(this.temp.auditInfo).then(data=>{
          me.temp.dialogAudit = false;
          me.tempItem({contractId:me.temp.temp.contractId});
      })

    },
    async closeTemp(item) {
      let me = this;
      const res = await this.$dialog.confirm({
        title: '确认',
        text: '确定要终止此条临时费用吗？',
      });
      if (res == true) {
        ContractApi.closeTemp({tempId: item.tempId}).then(data => {
            me.tempItem({contractId:me.temp.temp.contractId});
        })
      }
    },

    historyItem (item) {
      this.history.dialogHistory = true;
      this.history.historyItem = item;
      let me = this;
      ContractApi.getHistory({contractId:item.contractId}).then(data=>{
          me.history.desserts = data;
      })
    },

    viewUpdateDescription(item){
      this.history.dialogDescription = true;
      this.history.updateDescription = item.updateDescription;
    },

    viewHistoryItem(item){
      this.history.dialogHistory = false;
      this.history.historyBack = true;
      this.$emit("viewCallback", {recordId:item.recordId})
    },

    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    save () {
      if(this.add.createType == 2 && !this.add.linkContract){
        this.$dialog.error({
          text: "请选择关联合同",
          title: "错误"
        })
        return;
      }
      this.close()
      this.$emit("addCallback", {addType:this.add.addType, createType:this.add.createType, linkContract:this.add.linkContract})
    },
    editItem(item){
      this.$emit("addCallback", {contractId:item.contractId})
    },
    changeItem(item){
      this.$emit("changeCallback", {contractId:item.contractId})
    },
    viewItem(item){
      this.$emit("viewCallback", {contractId:item.contractId})
    },
    _hasButtonPermission(name){
      let buttonPriviledgeList = this.buttonPriviledgeList
      let hasButton =false
      for(let i=0;i<buttonPriviledgeList.length;i++){
        if(buttonPriviledgeList[i].name==name){
          if(buttonPriviledgeList[i].hasPriviledge=='Y'){
            return true
          } else {
            return false
          }
        }
      }
      return false
    },
  },
}
</script>

<style scoped>
label{
  font-size: 13px;
  line-height: 40px
}
</style>